export const refs = {
  body: document.querySelector('body'),
  container: document.querySelector('.container'),
  library: document.querySelector('.library'),
  header: document.querySelector('header'),
  tuiPage: document.querySelector('.tui-pagination'),
  footer: document.querySelector('.footer'),
  scrollBtn: document.querySelector('.scroll-up'),
  watchedBtn: document.querySelector('.watched'),
  queueBtn: document.querySelector('.queue'),
  modal: document.querySelector('.modal-overlay'),
  movieList: document.querySelector('.movie-list-js'),
  movieModal: document.querySelector('.movie-modal'),
  movieModalWrapper: document.querySelector('.movie-modal-wrapper-js'),
  movieModalClose: document.querySelector('.movie-modal-close-js'),
  toggle: document.querySelector('.theme-switch__toggle'),
  emptyPage: document.querySelector('.empty-page'),
  teamModal: document.querySelector('.team-modal'),
};
